/**
 * Created by Ivan on 27.09.2026
 */

const PiggyBankWindow = Prefab.createWindow("piggy_bank_window", "piggybankwindow_prefab_json");
